<template>
  <div
    class="sticky top-0 z-[2010] flex w-full items-center justify-center gap-2.5 bg-linear-to-r from-red-600 to-red-700 px-6 py-3 text-center text-sm font-semibold leading-snug tracking-wide text-white shadow-md"
    data-cy="web-pos-blocked-banner"
    role="alert"
  >
    <svg
      class="h-5 w-5 shrink-0"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <span>{{ t("compliance.web-pos-blocked-banner") }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { LogService } from "@/services/logging";
import POSConfigModule from "@/store/modules/pos-config";

/**
 * Persistent, non-dismissible banner shown to group users in fiscalised
 * countries on the web POS (FIS-42). Everything stays browsable — including
 * editing an order — but sales cannot be confirmed, and this banner explains
 * why. Rendered below the navbar and kept sticky so it never scrolls away.
 */
export default defineComponent({
  name: "WebPosBlockedBanner",
  setup() {
    const { t } = useI18n({});
    onMounted(() => {
      LogService.info("Web POS blocked banner mounted", {
        groupId: POSConfigModule.groupId,
        countryCode: POSConfigModule.getGroupCountryCode,
      });
    });
    return { t };
  },
});
</script>
